import { render, staticRenderFns } from "./ds-conf-form.vue?vue&type=template&id=7a4934aa&scoped=true&"
import script from "./ds-conf-form.vue?vue&type=script&lang=ts&"
export * from "./ds-conf-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4934aa",
  null
  
)

export default component.exports